'use client';
import React from 'react';
import { TrackingManager } from '@benzinga/tracking-manager';
import styled from '@benzinga/themetron';
import { Icon } from '@benzinga/core-ui';
import { faPaperPlane as faPaperPlaneLight } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faPaperPlane as faPaperPlaneSolid } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { WidgetToolbarContext } from '../toolbarContext';
import { WidgetContext } from '../context';
import { SessionContext } from '@benzinga/session-context';
import { PersistStorageKey } from '@benzinga/session';

export const useFlightModeToolBar = (flightMode: boolean | undefined, setFlightMode: (flightMode: boolean) => void) => {
  const widgetToolbar = React.useContext(WidgetToolbarContext);
  const widgetContext = React.useContext(WidgetContext);
  const session = React.useContext(SessionContext);
  const trackingManager = session.getManager(TrackingManager);

  const handleFlightModeChange = React.useCallback(() => {
    trackingManager.trackWidgetEvent('click', widgetContext.widgetType, {
      layout_id: window.sessionStorage.getItem(PersistStorageKey.activeLayoutId) ?? undefined,
      widget_id: widgetContext.widgetId,
      widget_sub_type: 'flight_mode',
      widget_sub_type_value: !flightMode,
    });
    setFlightMode(!flightMode);
  }, [flightMode, setFlightMode, trackingManager, widgetContext.widgetId, widgetContext.widgetType]);

  React.useEffect(() => {
    const defineControls = widgetToolbar.defineControls;
    defineControls({
      key: 'flight_mode',
      submenuNode: {
        action: handleFlightModeChange,
        icon: <StyledIcon icon={flightMode ? faPaperPlaneSolid : faPaperPlaneLight} />,
        key: 'flight_mode',
        name: `${flightMode ? 'Disable' : 'Enable'} Flight Mode`,
        type: 'Item',
      },
    });
  }, [flightMode, handleFlightModeChange, setFlightMode, widgetToolbar.defineControls]);
};

const StyledIcon = styled(Icon)`
  color: ${props => props.theme.colors.foregroundInactive} !important;
  font-size: 0.8em;
`;
